enum TypeEvidence {
    IMAGE = 'image',
    VIDEO = 'video',
    COMMENT = 'comment',
    DOCUMENTS = 'documents',
    SIGN = 'sign'
}

export { TypeEvidence }